// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { Form, Button, Alert, Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { FaEnvelope, FaPaperPlane } from 'react-icons/fa';
import apiClient from '../apis/apiClient';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email.trim()) return setError('Bitte geben Sie Ihre E-Mail-Adresse ein.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return setError('Ungültige E-Mail-Adresse.');

    setLoading(true);

    try {
      await apiClient.post('/auth/forgot-password', { email });
      setMessage('Ein Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail gesendet.');
      setLoading(false);
      setEmail('');
    } catch (err) {
      setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
      setLoading(false);
    }
  };

  return (
    <Container className="login-container">
      <Row className="justify-content-center align-items-center min-vh-100">
        <Col md={8} lg={6} xl={5}>
          <Card className="login-card shadow-lg border-0">
            <Card.Body className="p-4 p-md-5">
              <h3 className="text-center mb-4">Passwort vergessen</h3>

              {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}
              {message && <Alert variant="success" dismissible onClose={() => setMessage('')}>{message}</Alert>}

              <Form onSubmit={handleForgotPassword}>
                <Form.Group className="mb-3">
                  <Form.Label>E-Mail-Adresse</Form.Label>
                  <div className="input-group">
                    <span className="input-group-text bg-light">
                      <FaEnvelope className="text-muted" />
                    </span>
                    <Form.Control
                      type="email"
                      placeholder="Geben Sie Ihre E-Mail-Adresse ein"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </Form.Group>

                <Button type="submit" variant="primary" className="w-100 py-2 fw-bold" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" className="me-2" />
                      Senden...
                    </>
                  ) : (
                    <>
                      <FaPaperPlane className="me-2" />
                      Zurücksetzen senden
                    </>
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
